import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SwUpdate } from '@angular/service-worker'
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { GlobalService } from './shared/services/global.service';
import { BackgroundFilesService } from './shared/services/background-files.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
	title = 'pmsangular';
	showMenu: boolean = true;

	changeLenguage(value) {
		this._gS.changeLenguage(value)
	}
	// updateCode:boolean = false;

	doBeforeUnload($event) {
		if (this._bgFile.getStatusPendingList() == 'pending') {
			return $event.returnValue = 'Your changes will not be saved';
		}
	}

	constructor(
		private _bgFile: BackgroundFilesService,
		public router: Router,
		public _gS: GlobalService,
		updates: SwUpdate
	) {
		this._gS.setLenguage();
		
		updates.versionUpdates.subscribe(event => {
			if (event.type === 'VERSION_READY') {
				this._gS.updateCode = true;
				updates.activateUpdate().then(() => document.location.reload());
			}
		});
	}

	ngAfterViewInit() {
		this.router.events
			.subscribe((event) => {
				if (event instanceof NavigationStart) {
					this._gS.loading = true;
				}
				else if (
					event instanceof NavigationEnd ||
					event instanceof NavigationCancel
				) {
					this._gS.loading = false;
					this.showMenu = event.url != '/login' ? true : false;
				}
			});
	}
}
